import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";

import CurrencyInput from "react-currency-input-field";

const validationSchema = Yup.object().shape({
  discount: Yup.number(),
  late_payment: Yup.boolean(),
  transport_payment_value: Yup.number(),
});

const StudentConfig = ({ id, year }) => {
  const [studentId, setStudentId] = useState(id);
  const [configId, setConfigId] = useState();
  const { postData, patchData, getData } = useDataFetch();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      transport_payment_value: false,
    },
  });

  const { data: dataconfig } = getData(
    ["students", studentId],
    `/student/configuration/${id}?year=${year}`,
    {
      enabled: !!studentId,
    }
  );

  const { mutate: createConfig } = postData(
    "/student-configurations",
    {},
    {},
    {
      onSuccess: (data) => {
        console.log(data?.data?.id);
        setConfigId(data?.data?.id);
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const { mutate: updateConfig, isLoading: isPostLoading } = patchData(
    "/student-configurations",
    {},
    {
      onSuccess: (data) => {
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  useEffect(() => {
    if (dataconfig?.data && dataconfig?.data?.length > 0) {
      const data = dataconfig?.data[0];
      setConfigId(data?.id);
      setValue("discount", data?.discount ?? 0);
      setValue("late_payment", data?.late_payment ?? false);
      setValue("transport_payment_value", data?.transport_payment_value ?? 0);
    } else {
      setValue("discount", 0);
      setValue("late_payment", false);
      setValue("transport_payment_value", 0);
    }
  }, [dataconfig]);

  const onSubmit = (data) => {
    if (configId) {
      updateConfig({ id: configId, ...data });
    } else {
      createConfig({ student_id: studentId, ...data });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className={`col-md-4 mb-3 `}>
          <label htmlFor="firstName">% de descuento</label>
          <input
            type="number"
            className="form-control"
            {...register("discount")}
            min={0}
            max={100}
          />
        </div>
        <div className={`col-md-4 mb-3 `}>
          <label htmlFor="firstName">Valor del Transporte</label>

          <Controller
            name="transport_payment_value"
            control={control}
            render={({ field }) => (
              <CurrencyInput
                className="form-control"
                decimalsLimit={0}
                decimalSeparator=","
                groupSeparator="."
                onValueChange={(value, name, values) => {
                  console.log(value, name, value);
                  field.onChange(value);
                }}
              />
            )}
          />
        </div>

        <div className={`col-md-4 mb-3`}>
          <label htmlFor="firstName">Permitir el Pago sin Interes</label>
          <div className="custom-control custom-checkbox mb-3 checkbox-warning check-xl">
            <Controller
              name="late_payment"
              control={control}
              render={({ field }) => (
                <div>
                  <input
                    id="late_payment"
                    checked={field.value}
                    type="checkbox"
                    className="custom-control-input"
                    onChange={() => {
                      console.log("hola", field.value);
                      field.onChange(!field.value);
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="late_payment"
                  ></label>
                </div>
              )}
            />
          </div>
        </div>
      </div>

      <hr className="mb-4" />
      <button
        className="btn btn-primary btn-lg btn-block"
        type="submit"
        disabled={isPostLoading}
      >
        Guardar
      </button>
    </form>
  );
};

export default StudentConfig;
